import { FormSection } from "Components/Shared/FormSection";
import { RelatedPartiesAccordionList } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/RelatedPartiesAccordionList";
import type { RelatedPartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.RelatedParties;

type Props = {
  relatedParties: Array<RelatedPartyDto>;
  isReadOnly?: boolean;
  owningPartyID?: string | null;
};

export const RelatedPartiesSection = ({
  relatedParties,
  isReadOnly,
  owningPartyID,
}: Props) => {
  const { t } = useResource();

  return (
    <FormSection legend={t(COMPONENT_RESOURCES.Title)}>
      <RelatedPartiesAccordionList
        relatedParties={relatedParties}
        isReadOnly={isReadOnly}
        owningPartyID={owningPartyID}
      />
    </FormSection>
  );
};
